import { message } from 'antd'
import {
  FETCH_DESKTOP_PROFILE_SUCCESS,
  FETCH_DESKTOP_PROFILE_ERROR,
  LOGIN_DESKTOP_PENDING,
  LOGIN_DESKTOP_SUCCESS,
  LOGIN_DESKTOP_ERROR,
  LOGOUT_DESKTOP_PENDING,
  LOGOUT_DESKTOP_SUCCESS,
  LOGOUT_DESKTOP_ERROR,
  REGISTER_DESKTOP_PENDING,
  REGISTER_DESKTOP_SUCCESS,
  REGISTER_DESKTOP_ERROR,
} from '../../actions/desktop/auth'

const initialState = {
  user: null,
  loggingIn: false,
  loggingOut: false,
  loginErrors: null,
  error: null,
  success: false,
}

export default function desktopAuth(state = initialState, action = {}) {
  switch (action.type) {
    case LOGIN_DESKTOP_PENDING:
      return Object.assign({}, initialState, {
        loggingIn: true,
        loading: true,
      })

    case LOGIN_DESKTOP_SUCCESS:
      let user = (action || {}).data.Reseller
      localStorage.setItem('user', JSON.stringify(user))
      localStorage.setItem('Authorization', user.Id)
      console.log(user)
      return Object.assign({}, state, {
        user: user,
        loggingIn: false,
        loginErrors: null,
        loading: false,
      })

    case LOGIN_DESKTOP_ERROR:
      return {
        ...state,
        loggingIn: false,
        loading: false,
        user: null,
        loginErrors: action.message,
      }

    case LOGOUT_DESKTOP_PENDING:
    case LOGOUT_DESKTOP_SUCCESS:
    case LOGOUT_DESKTOP_ERROR:
      localStorage.clear()
      return {
        ...state,
        loggingOut: false,
        user: null,
        loginErrors: null,
      }

    case FETCH_DESKTOP_PROFILE_SUCCESS:
      localStorage.setItem('user', JSON.stringify((action || {}).data))
      return Object.assign({}, state, {
        user: (action || {}).data,
        loggingIn: false,
        loginErrors: null,
      })

    case FETCH_DESKTOP_PROFILE_ERROR:
      return Object.assign({}, state, {
        user: null,
        loggingIn: false,
        loginErrors: null,
      })

    case REGISTER_DESKTOP_SUCCESS:
      const { email, message: result } = (action || {}).data
      message.success(result)
      return {
        ...state,
        busy: false,
        success: true,
        user: { email },
      }

    case REGISTER_DESKTOP_ERROR:
      message.error(action.message)
      return {
        ...state,
        busy: false,
        error: action.message,
      }

    default:
      return { ...state }
  }
}
